var render = function render(){
  var _vm$option, _vm$option$userDetail, _vm$option2, _vm$option3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('img', {
    staticClass: "mr-2",
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "width": "28",
      "height": "28",
      "src": ((_vm$option = _vm.option) === null || _vm$option === void 0 ? void 0 : (_vm$option$userDetail = _vm$option.userDetail) === null || _vm$option$userDetail === void 0 ? void 0 : _vm$option$userDetail.photo) || _vm.$getInitials((_vm$option2 = _vm.option) === null || _vm$option2 === void 0 ? void 0 : _vm$option2.name)
    }
  }), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v(" " + _vm._s((_vm$option3 = _vm.option) === null || _vm$option3 === void 0 ? void 0 : _vm$option3.name) + " ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }